import SidekickApp from './pages/content/SidekickApp';

export const App = () => {
  return <SidekickApp />;
};
